import type { FaireProductEntity } from "../../entity_types/product";

export const p_qmzks9q3d3: FaireProductEntity = {
  token: "p_qmzks9q3d3",
  type: "product",
  name: "Dainty Gold CZ Stud Earrings ES035",
  brandToken: "b_dmzj4e52w6",
  brandName: "AAJewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/0bc9b3d84eb47a95fbd9202e8f7676942b4d30e60885c9d3f457918dc6e6536e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/edc37b925415c6549ab084e8c9b848abfaa44e54a4ae6a28050f2544de894fe6.png",
    "https://cdn.faire.com/fastly/d9758e874e6dc2d225c018bdb5e7f228e515cc15dd31957b134be5e971640765.png",
    "https://cdn.faire.com/fastly/df7ba3485db1b07cb8c4eb58fce563cb51669f81e7dc3827d24dbcbba4ebbe35.png",
    "https://cdn.faire.com/fastly/583a16d595f5307e58fee56c61a14d2d3c219ade4ec2e6540f70381edef35830.jpeg",
    "https://cdn.faire.com/fastly/a3f8014afc2877fe6821ba64dab5b8e9116d5544300bb949a50a43eec4afbd21.jpeg",
    "https://cdn.faire.com/fastly/8f2a8b60b495877d5f30996ceb7d635a9a90e321acdb85572d116607490d0a20.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "DUAL SPARK BAR EARRINGS\nModern meets timeless. These asymmetrical earrings feature a sleek vertical bar lined with sparkling cubic zirconia and a delicate pear-cut drop for a refined, eye-catching look. Designed for everyday elegance, they add just the right amount of shine from morning coffee to evening glow.\n\nDETAILS\n• Sold as PAIRS\n• 18k Gold Thick Plated on Sterling Silver\n• 10mm × 6mm\n• Hypoallergenic & Nickel-Free\n• Lightweight & Comfortable for Daily Wear\n",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:00.835Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
